





















































































































































import Vue from "vue";
import VaNoDataTag from "@/components/molecules/VaNoDataTag.vue";
import VaTableTop from "@/components/molecules/VaTableTop.vue";
import VaCard from "@/components/molecules/VaCard.vue";
import VaTextField from "@/components/atoms/VaTextField.vue";
import VaButton from "@/components/atoms/VaButton.vue";
import validationMixin from "@/components/mixins/validationMixin";
import dataTableMixin from "@/components/mixins/dataTableMixin";
import { AdminUser, adminUserConfig } from "@/models/adminUser";
import userService from "@/services/userService";
import { clone } from "lodash";
import VaBadge from "../atoms/VaBadge.vue";
import AuthService from "@/services/authService";

const emptyAdmin = {
  email: "",
  firstName: "",
  lastName: "",
} as Partial<AdminUser>;

export default Vue.extend({
  name: "AdminUsers",
  mixins: [validationMixin, dataTableMixin],
  components: {
    VaButton,
    VaTextField,
    VaCard,
    VaBadge,
    VaTableTop,
    VaNoDataTag,
  },
  data() {
    return {
      storeName: "adminUsers",
      dialog: false,
      user: {} as Partial<AdminUser>,
      tableConfig: adminUserConfig,
      mailChecked: false,
      loading: false,
    };
  },
  methods: {
    onCreate(): void {
      this.user = clone(emptyAdmin);
      this.mailChecked = false;
      this.loading = false;
      this.dialog = true;
      this.$nextTick(() => {
        (
          this.$refs.newGroupForm as Vue & { resetValidation: () => void }
        ).resetValidation();
      });
    },
    async onResend(user: AdminUser): Promise<void> {
      this.user = user;
      this.onInvite();
    },
    async onInvite(): Promise<void> {
      this.loading = true;
      try {
        if (!this.user.email || !this.user.firstName || !this.user.lastName)
          return;
        await userService.inviteAdmin(
          this.user.email,
          this.user.firstName,
          this.user.lastName
        );
        this.dialog = false;
        this.$store.dispatch("adminUsers/fetchList"),
          this.$store.commit(
            "notifications/displayNotification",
            { message: this.$t("usersList.invitationSent"), type: "success" },
            { root: true }
          );
      } catch (e) {
        this.$store.commit(
          "notifications/displayNotification",
          { message: e, type: "error" },
          { root: true }
        );
      } finally {
        this.loading = false;
      }
    },
    async onDeleteInvitation(user: AdminUser): Promise<void> {
      this.$store.commit("notifications/displayConfirmDialog", {
        visible: true,
        title: this.$i18n.t("usersList.deleteInvitation"),
        description: `${this.$i18n.t("usersList.deleteInvitationConfirm")}`,
        callback: async () => {
          this.loading = true;
          try {
            if (!user.companyUserInvitationId) return;
            await userService.deleteInvite(user.companyUserInvitationId);
            this.$store.dispatch("adminUsers/fetchList"),
              this.$store.commit(
                "notifications/displayNotification",
                {
                  message: this.$t("usersList.invitationDeleted"),
                  type: "success",
                },
                { root: true }
              );
          } catch (e) {
            this.$store.commit(
              "notifications/displayNotification",
              { message: e, type: "error" },
              { root: true }
            );
          } finally {
            this.loading = false;
          }
        },
      });
    },
    async onDeleteUser(user: AdminUser): Promise<void> {
      const isMyAccount =
        user.email === this.$store.getters["session/user"]?.email;

      this.$store.commit("notifications/displayConfirmDialog", {
        visible: true,
        title: isMyAccount
          ? this.$i18n.t("usersList.deleteMyAccount")
          : this.$i18n.t("usersList.deleteAccount"),
        description: isMyAccount
          ? this.$i18n.t("usersList.deleteMyAccountConfirm")
          : this.$i18n.t("usersList.deleteAccountConfirm"),
        callback: async () => {
          this.loading = true;
          try {
            if (!user.userId) return;
            await userService.deleteAdminUser(user.userId);
            this.$store.dispatch("adminUsers/fetchList"),
              this.$store.commit(
                "notifications/displayNotification",
                {
                  message: this.$t("usersList.userDeleted"),
                  type: "success",
                },
                { root: true }
              );
            if (isMyAccount) {
              AuthService.logout();
            }
          } catch (e) {
            this.$store.commit(
              "notifications/displayNotification",
              { message: e, type: "error" },
              { root: true }
            );
          } finally {
            this.loading = false;
          }
        },
      });
    },
    async onCheck(): Promise<void> {
      // "U801", "The selected user is already part of a different company." -> KO, con messaggio negativo
      // "U803", "The selected user is already part of your company." -> Success, con messaggio "..."
      // "U804", "Admin user not found." -> Mostri il form completo
      // 200 -> Utente esiste, ma non ha una company -> non serve mostrare il form ma si può mandare subito l'invito
      try {
        if (!this.user.email) return;
        const res = (await userService.checkAdminMail(this.user.email)) as any;
        this.user.firstName = res?.data?.firstName;
        this.user.lastName = res?.data?.lastName;
        this.onInvite();
      } catch (e) {
        if (e.response?.data?.errorCode == "U804") {
          this.mailChecked = true;
        } else if (e.response?.data?.errorCode == "U803") {
          this.$store.commit(
            "notifications/displayNotification",
            { message: this.$t("usersList.alreadyInCompany"), type: "success" },
            { root: true }
          );
          this.dialog = false;
        } else if (e.response?.data?.errorCode == "U801") {
          this.$store.commit(
            "notifications/displayNotification",
            { message: this.$t("usersList.inOtherCompany"), type: "error" },
            { root: true }
          );
        } else {
          this.$store.commit(
            "notifications/displayNotification",
            { message: e, type: "error" },
            { root: true }
          );
        }
      }
    },
  },
});
